module.exports = __webpack_public_path__ + "667e0f848b39b75e193ff2bd88546ef9.svg";